import { format, parseISO } from "date-fns/esm";

/**
 * Utilidades para formatear y obtener datos del trip
 */

export const getLastPosition = (data) => {
  if (!data?.route) return {};
  if (data?.route.length === 0) return {};
  const { latitude, longitude } = data?.route[data?.route.length - 1];
  return { lat: latitude, lng: longitude };
};

export const getLastDate = (data) => {
  if (!data?.route) return "";
  if (!data?.route[0]) return "";
  const { date } = data?.route[data?.route.length - 1];
  if (!date) return "";
  return format(parseISO(date), "dd/MM/yyyy HH:mm");
};

export const getStartDate = (data) => {
  if (!data?.route) return "";
  if (!data?.route[0]) return "";
  const { date } = data?.route[0];
  if (!date) return "";
  return format(parseISO(date), "dd/MM/yyyy HH:mm");
};

export const getPaths = (data) => {
  if (!data?.route) return [];
  if (!data?.route && data.route.length === 0) return [];
  return data.route.map((item) => {
    const { latitude, longitude } = item;
    return { lat: latitude, lng: longitude };
  });
};

export const getActiveClassTab = (indexTab, tabActive) => {
  if (indexTab === tabActive)
    return `inline-flex p-4 text-[#222222] rounded-t-lg border-b-2 border-[#222222] group font-[Gravity]`;
  return `inline-flex p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 group font-[Gravity]`;
};
